import React, { useEffect, useState } from 'react';
import axios from '../../services/axios'; // Para chamadas gerais (ex: NF-e e vendedores)
import axiosNFE from '../../services/axios_nfe'; // Para chamadas específicas da API /api/sicweb
import {
  Box,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  TablePagination,
  Button,
  Paper,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Backdrop
} from '@mui/material';
import {
  Send as SendIcon,
  CheckCircle as CheckCircleIcon,
  Replay as ReplayIcon,
  Cancel as CancelIcon,
  FileDownload as FileDownloadIcon,
  Delete as DeleteIcon,
  Email as EmailIcon,
  Edit as EditIcon,
  Block as BlockIcon,
  PictureAsPdf as PictureAsPdfIcon,
  ReceiptLong as ReceiptLongIcon,
  ExpandMore as ExpandMoreIcon,
} from '@mui/icons-material';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import AutocompleteWithClear from '../../components/AutocompleteWithClear';
import { useAuth } from '../../contexts/AuthContext';
import db from '../../services/db'; // Importe seu serviço de IndexedDB
function NfeList() {
    const { user,selectCompany } = useAuth();
  const navigate = useNavigate();
  const [nfeList, setNfeList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedNfes, setSelectedNfes] = useState([]);
  const [lastSelectedIndex, setLastSelectedIndex] = useState(null);
  const [vendedores, setVendedores] = useState([]);
  const [filters, setFilters] = useState({
    filtro: '',
    dataInicio: '',
    dataFim: '',
    serie: '',
    numeroNota: '',
    descricaoSerie: 'T',
    vendedor: null,
    status: 'Todos',
  });
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false); // Estado para indicar carregamento

  // Estados para o popup (Dialog)
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupTitle, setPopupTitle] = useState('');
  const [popupContent, setPopupContent] = useState([]);

  // Carrega os vendedores
  useEffect(() => {
    axios
      .get('/api/vendedores')
      .then((res) => setVendedores(res.data))
      .catch((err) => console.error('Erro ao buscar vendedores:', err));
  }, []);

  // Busca a lista de NF-e conforme os filtros e paginação
  const fetchNfeList = async () => {
    try {
      const response = await axios.get('/api/nfe', {
        params: {
          filtro: filters.filtro,
          periodoInicial: filters.dataInicio,
          periodoFinal: filters.dataFim,
          serie: filters.serie,
          numeroNota: filters.numeroNota,
          descricaoSerie: filters.descricaoSerie,
          idVendedor: filters.vendedor ? filters.vendedor.codigo : null,
          status: filters.status === 'Todos' ? null : filters.status,
          page,
          size: rowsPerPage,
        },
      });
      setNfeList(response.data.content);
      setTotalCount(response.data.totalElements);
    } catch (error) {
      console.error('Erro ao buscar NF-es:', error);
    }
  };

  const fetchNfeLists = async () => {
    try {
      const response = await axios.get('/autocomplete', {
        params: {
          entityName: 'ComCliente',
          fields:'idCliente,pessoa.nome,pessoa.documento',
          large:false
        },
      });
     
    } catch (error) {
      console.error('Erro ao buscar NF-es:', error);
    }
  };

  useEffect(() => {
    fetchNfeList();
    fetchNfeLists();
  }, [filters, page, rowsPerPage]);

  const handleFilterChange = (field, value) => {
    setFilters({ ...filters, [field]: value });
    setPage(0);
  };

  // Função para abrir o popup com título e conteúdo
  const openPopup = (title, contentArray) => {
    setPopupTitle(title);
    setPopupContent(contentArray);
    setPopupOpen(true);
  };

  // Envia NF-e uma por uma com indicador de carregamento
  const handleEnviar = async () => {
    if (selectedNfes.length === 0) return;
    setLoading(true);
    const responses = [];
    for (const nfe of selectedNfes) {
      try {
        const response = await axiosNFE.post('/api/sicweb/enviarNFE', [nfe.idNFE]);
        responses.push(`NF-e ${nfe.numero}: ${response.data}`);
      } catch (error) {
        console.error('Erro ao enviar NF-e:', error);
        responses.push(`NF-e ${nfe.numero}: Erro - ${error.message || "Erro desconhecido"}`);
      }
    }
    setLoading(false);
    openPopup("Resposta Enviar NF-e", responses);
    fetchNfeList();
  };

  // Verifica o status de uma única NF-e
  const handleVerificarStatus = () => {
    if (selectedNfes.length === 0) return;
    if (selectedNfes.length !== 1) {
      console.warn('Selecione apenas uma NF-e para verificar o status.');
      return;
    }
    const id = selectedNfes[0].idNFE;
    setLoading(true);
    axiosNFE.post('/api/sicweb/verificarStatus', [id])
      .then(response => {
        openPopup("Resposta Verificar Status", response.data);
        fetchNfeList();
      })
      .catch(error => {
        console.error('Erro ao verificar status:', error);
        openPopup("Erro Verificar Status", [error.message || "Erro desconhecido"]);
      })
      .finally(() => setLoading(false));

  };

  // Obtém o retorno de envio de uma NF-e
  const handleRetornoEnvio = () => {
    if (selectedNfes.length !== 1) {
      console.warn('Selecione apenas uma NF-e para obter retorno de envio.');
      return;
    }
    const id = selectedNfes[0].idNFE;
    setLoading(true);
    axiosNFE.get(`/api/sicweb/retornoEnvio?idNota=${id}`)
      .then(response => {
        fetchNfeList();
        openPopup("Retorno de Envio", [response.data]);
       
      })
      .catch(error => {
        console.error('Erro ao obter retorno de envio:', error);
        openPopup("Erro Retorno Envio", [error.message || "Erro desconhecido"]);
      })
      .finally(() => setLoading(false));
     
  };

  // Exporta o XML da NF-e
  const handleExportarXML = () => {
    if (selectedNfes.length !== 1) {
      console.warn('Selecione apenas uma NF-e para exportar o XML.');
      return;
    }
    const id = selectedNfes[0].idNFE;
    setLoading(true);
    axiosNFE.get(`/api/sicweb/msgXML?idNota=${id}`)
      .then(response => {
        fetchNfeList();
        //openPopup("XML da NF-e", [response.data]);
        const blob = new Blob([response.data], { type: 'application/xml' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      })
      .catch(error => {
        console.error('Erro ao exportar XML:', error);
        openPopup("Erro Exportar XML", [error.message || "Erro desconhecido"]);
      })
      .finally(() => setLoading(false));
  
  };

  // Obtém a mensagem de envio da NF-e
  const handleMsgEnviarNFE = () => {
    if (selectedNfes.length !== 1) {
      console.warn('Selecione apenas uma NF-e para obter a mensagem.');
      return;
    }
    const id = selectedNfes[0].idNFE;
    setLoading(true);
    axiosNFE.get(`/api/sicweb/msgEnviarNFE?idNota=${id}`)
      .then(response => {
        fetchNfeList();
        openPopup("Mensagem de Envio", [response.data]);
      
      })
      .catch(error => {
        console.error('Erro ao obter a mensagem:', error);
        openPopup("Erro Mensagem Envio", [error.message || "Erro desconhecido"]);
      })
      .finally(() => setLoading(false));
     
  };

  // Chamada para gerar o DANF (PDF)
  const handleGerarDANFE = async () => {
    if (selectedNfes.length !== 1) {
      console.warn('Selecione apenas uma NF-e para gerar DANFE.');
      return;
    }
    const id = selectedNfes[0].idNFE;
    const storedUserSic = await db.currentUserSic.get('currentUser');
    // Solicita a matriz ao usuário (pode ser ajustado conforme a necessidade)
    console.log(storedUserSic)
    const matriz = selectCompany.entityManager

    setLoading(true);
    axiosNFE.get(`/api/sicweb/danf?idNota=${id}&matriz=${matriz}`, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        // Cria um blob e abre em uma nova aba
        fetchNfeList();
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      })
      .catch(error => {
        console.error("Erro ao gerar DANFE:", error);
        openPopup("Erro Gerar DANFE", [error.message || "Erro desconhecido"]);
      })
      .finally(() => setLoading(false));
      fetchNfeList();
  };

  // Outros métodos (handleCancelar, handleEnviarEmail, handleCorrigirNota, handleInutilizar, handleGerarNFCE) podem ser implementados de forma similar
  const handleCancelar = () => {
    console.log('Cancelar NF-e');
  };

  const handleEnviarEmail = () => {
    console.log('Enviar Email');
  };

  const handleCorrigirNota = () => {
    console.log('Corrigir Nota');
  };

  const handleInutilizar = () => {
    console.log('Inutilizar NF-e');
  };

  const handleGerarNFCE = () => {
    console.log('Gerar NFC-e');
  };

  // Paginação
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Formatação de data
  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), 'dd/MM/yyyy HH:mm');
    } catch {
      return '-';
    }
  };

  // Seleção de linha na tabela
  const isSelected = (nfe) =>
    selectedNfes.findIndex((selected) => selected.numero === nfe.numero) !== -1;

  const handleRowClick = (event, nfe, index) => {
    if (event.shiftKey && lastSelectedIndex !== null) {
      const start = Math.min(lastSelectedIndex, index);
      const end = Math.max(lastSelectedIndex, index);
      const range = nfeList.slice(start, end + 1);
      let newSelected = [...selectedNfes];
      range.forEach((item) => {
        if (!newSelected.some((s) => s.numero === item.numero)) {
          newSelected.push(item);
        }
      });
      setSelectedNfes(newSelected);
    } else {
      if (isSelected(nfe)) {
        setSelectedNfes(selectedNfes.filter((item) => item.numero !== nfe.numero));
      } else {
        setSelectedNfes([...selectedNfes, nfe]);
      }
    }
    setLastSelectedIndex(index);
  };

  // Renderização do status da NF-e
  const renderStatus = (status) => {
    switch (status) {
      case 'AUTORIZADA':
        return (
          <Box sx={{ textAlign: 'center' }}>
            🟢 <br />
            <strong>Autorizada</strong>
          </Box>
        );
      case 'REJEITADA':
        return (
          <Box sx={{ textAlign: 'center' }}>
            🔴 <br />
            <strong>Rejeitada</strong>
          </Box>
        );
      case 'ENVIADA':
        return (
          <Box sx={{ textAlign: 'center' }}>
            🟡 <br />
            <strong>Enviada</strong>
          </Box>
        );
      case 'NOVA':
        return (
          <Box sx={{ textAlign: 'center' }}>
            ⚪ <br />
            <strong>Nova</strong>
          </Box>
        );
      case 'CANCELADA':
        return (
          <Box sx={{ textAlign: 'center' }}>
            🟠 <br />
            <strong>Cancelada</strong>
          </Box>
        );
      case 'INUTILIZADA':
        return (
          <Box sx={{ textAlign: 'center' }}>
            🔵 <br />
            <strong>Inutilizada</strong>
          </Box>
        );
      case 'DENEGADA':
        return (
          <Box sx={{ textAlign: 'center' }}>
            🔴 <br />
            <strong>Denegada</strong>
          </Box>
        );
      default:
        return '-';
    }
  };

  // Controle dos botões conforme o status da NF-e selecionada
  const getButtonControll = () => {
    const estadoBotoes = {
      btnRetornoEnvio: true,
      btnVerificarStatus: true,
      btnEnviar: true,
      btnCancelar: true,
      btnImprimir: true,
      btnExportaXML: true,
      btnExcluir: true,
      btnEnvEmail: true,
      btnCorrigirNota: true,
      btnInutilizar: true,
      btnDANFE: true,
      btnNFCE: true,
    };

    if (selectedNfes.length > 0) {
      const statusNf = selectedNfes[0].statusSefaz;
      const statusDiferente = selectedNfes.some((nfe) => nfe.statusSefaz !== statusNf);
      const cupomFiscal = selectedNfes.some((nfe) => nfe.descricaoSerieNfe === 'NFCE');

      if (!statusDiferente) {
        switch (statusNf) {
          case 'NOVA':
            estadoBotoes.btnRetornoEnvio = false;
            estadoBotoes.btnVerificarStatus = false;
            estadoBotoes.btnEnviar = false;
            estadoBotoes.btnCancelar = true;
            estadoBotoes.btnImprimir = false;
            estadoBotoes.btnExportaXML = true;
            estadoBotoes.btnExcluir = false;
            estadoBotoes.btnEnvEmail = true;
            estadoBotoes.btnCorrigirNota = true;
            estadoBotoes.btnInutilizar = false;
            estadoBotoes.btnDANFE = false;
            estadoBotoes.btnNFCE = cupomFiscal ? false : true;
            break;
          case 'REJEITADA':
            estadoBotoes.btnRetornoEnvio = false;
            estadoBotoes.btnVerificarStatus = false;
            estadoBotoes.btnEnviar = false;
            estadoBotoes.btnCancelar = true;
            estadoBotoes.btnImprimir = true;
            estadoBotoes.btnExportaXML = true;
            estadoBotoes.btnExcluir = true;
            estadoBotoes.btnEnvEmail = true;
            estadoBotoes.btnCorrigirNota = true;
            estadoBotoes.btnInutilizar = false;
            estadoBotoes.btnDANFE = true;
            estadoBotoes.btnNFCE = true;
            estadoBotoes.btnCorrigirNota = false;
            if (cupomFiscal) {
              estadoBotoes.btnRetornoEnvio = true;
            }
            break;
          case 'AUTORIZADA':
            estadoBotoes.btnRetornoEnvio = false;
            estadoBotoes.btnVerificarStatus = false;
            estadoBotoes.btnEnviar = true;
            estadoBotoes.btnCancelar = false;
            estadoBotoes.btnImprimir = false;
            estadoBotoes.btnExportaXML = false;
            estadoBotoes.btnExcluir = true;
            estadoBotoes.btnEnvEmail = false;
            estadoBotoes.btnCorrigirNota = true;
            estadoBotoes.btnInutilizar = true;
            estadoBotoes.btnDANFE = false;
            estadoBotoes.btnNFCE = cupomFiscal ? false : true;
            if (cupomFiscal) {
              estadoBotoes.btnRetornoEnvio = true;
            }
            break;
          case 'INUTILIZADA':
            estadoBotoes.btnRetornoEnvio = false;
            estadoBotoes.btnVerificarStatus = false;
            estadoBotoes.btnEnviar = true;
            estadoBotoes.btnCancelar = true;
            estadoBotoes.btnImprimir = true;
            estadoBotoes.btnExportaXML = false;
            estadoBotoes.btnExcluir = true;
            estadoBotoes.btnEnvEmail = true;
            estadoBotoes.btnCorrigirNota = true;
            estadoBotoes.btnInutilizar = true;
            estadoBotoes.btnDANFE = true;
            estadoBotoes.btnNFCE = true;
            if (cupomFiscal) {
              estadoBotoes.btnRetornoEnvio = true;
            }
            break;
          case 'ENVIADA':
            estadoBotoes.btnRetornoEnvio = false;
            estadoBotoes.btnVerificarStatus = false;
            estadoBotoes.btnEnviar = true;
            estadoBotoes.btnCancelar = false;
            estadoBotoes.btnImprimir = false;
            estadoBotoes.btnExportaXML = false;
            estadoBotoes.btnExcluir = true;
            estadoBotoes.btnEnvEmail = false;
            estadoBotoes.btnCorrigirNota = true;
            estadoBotoes.btnInutilizar = false;
            estadoBotoes.btnDANFE = true;
            estadoBotoes.btnNFCE = true;
            if (cupomFiscal) {
              estadoBotoes.btnRetornoEnvio = true;
            }
            break;
          case 'CANCELADA':
            estadoBotoes.btnRetornoEnvio = true;
            estadoBotoes.btnVerificarStatus = false;
            estadoBotoes.btnEnviar = true;
            estadoBotoes.btnCancelar = true;
            estadoBotoes.btnImprimir = true;
            estadoBotoes.btnExportaXML = true;
            estadoBotoes.btnExcluir = true;
            estadoBotoes.btnEnvEmail = true;
            estadoBotoes.btnCorrigirNota = true;
            estadoBotoes.btnInutilizar = true;
            estadoBotoes.btnDANFE = true;
            estadoBotoes.btnNFCE = true;
            if (cupomFiscal) {
              estadoBotoes.btnRetornoEnvio = true;
            }
            break;
          case 'DENEGADA':
            estadoBotoes.btnRetornoEnvio = true;
            estadoBotoes.btnVerificarStatus = false;
            estadoBotoes.btnEnviar = true;
            estadoBotoes.btnCancelar = true;
            estadoBotoes.btnImprimir = true;
            estadoBotoes.btnExportaXML = false;
            estadoBotoes.btnExcluir = true;
            estadoBotoes.btnEnvEmail = true;
            estadoBotoes.btnCorrigirNota = true;
            estadoBotoes.btnInutilizar = true;
            estadoBotoes.btnDANFE = true;
            estadoBotoes.btnNFCE = true;
            break;
          default:
            break;
        }
      }
    }
    return estadoBotoes;
  };

  const buttonControll = getButtonControll();

  return (
    <Box sx={{ padding: { xs: 1, sm: 2 } }}>
      {/* Backdrop para indicar carregamento global */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Título da Página */}
      <Typography variant="h4" align="center" sx={{ mb: 3 }}>
        Listagem de NF-e
      </Typography>

      {/* Seção de Filtro Geral */}
      <Box sx={{ mb: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={8} md={6}>
            <TextField
              label="Filtro Geral (Cliente/CPF/CNPJ/NUMERO)"
              variant="outlined"
              size="small"
              value={filters.filtro}
              onChange={(e) => handleFilterChange('filtro', e.target.value)}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            md={6}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
          >
            <Button
              variant="contained"
              startIcon={<ExpandMoreIcon />}
              onClick={() => setShowAdvanced(!showAdvanced)}
            >
              {showAdvanced ? 'Ocultar Filtros Avançados' : 'Mais Filtros'}
            </Button>
          </Grid>
        </Grid>
      </Box>

      {/* Accordion com Filtros Avançados */}
      <Accordion
        expanded={showAdvanced}
        onChange={(e, expanded) => setShowAdvanced(expanded)}
        sx={{ mb: 3 }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>Filtros Avançados</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Data Início"
                variant="outlined"
                size="small"
                type="date"
                value={filters.dataInicio}
                onChange={(e) => handleFilterChange('dataInicio', e.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Data Fim"
                variant="outlined"
                size="small"
                type="date"
                value={filters.dataFim}
                onChange={(e) => handleFilterChange('dataFim', e.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Número Nota"
                variant="outlined"
                size="small"
                value={filters.numeroNota}
                onChange={(e) => handleFilterChange('numeroNota', e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl variant="outlined" size="small" fullWidth>
                <Select
                  label="Desc. Série"
                  value={filters.descricaoSerie}
                  onChange={(e) => handleFilterChange('descricaoSerie', e.target.value)}
                >
                  <MenuItem value="">Selecione</MenuItem>
                  <MenuItem value="T">TODAS</MenuItem>
                  <MenuItem value="NFCE">NFCE</MenuItem>
                  <MenuItem value="NFE">NFE</MenuItem>
                  <MenuItem value="NF">NF</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AutocompleteWithClear
                label="Vendedor"
                options={vendedores}
                getOptionLabel={(option) => (option ? `${option.codigo} - ${option.nome}` : '')}
                value={filters.vendedor || ''}
                onChange={(newValue) => handleFilterChange('vendedor', newValue)}
                onSelect={(selectedOption) => handleFilterChange('vendedor', selectedOption)}
                onClear={() => handleFilterChange('vendedor', null)}
                required={false}
                disabled={false}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl size="small" fullWidth>
                <Select
                  value={filters.status}
                  onChange={(e) => handleFilterChange('status', e.target.value)}
                  displayEmpty
                >
                  <MenuItem value="Todos">Todos</MenuItem>
                  <MenuItem value="Autorizada">Autorizada</MenuItem>
                  <MenuItem value="Denegada">Denegada</MenuItem>
                  <MenuItem value="Cancelada">Cancelada</MenuItem>
                  <MenuItem value="Inutilizada">Inutilizada</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* Botões de Ação */}
      <Box sx={{ mb: 3, textAlign: 'center' }}>
        <Button
          variant="contained"
          color="primary"
          disabled={buttonControll.btnEnviar || loading}
          onClick={handleEnviar}
          sx={{ m: 1 }}
          startIcon={<SendIcon />}
        >
          Enviar
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={buttonControll.btnVerificarStatus || loading}
          onClick={handleVerificarStatus}
          sx={{ m: 1 }}
          startIcon={<CheckCircleIcon />}
        >
          Verificar Status
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={buttonControll.btnRetornoEnvio || loading}
          onClick={handleRetornoEnvio}
          sx={{ m: 1 }}
          startIcon={<ReplayIcon />}
        >
          Retorno Envio
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={buttonControll.btnCancelar || loading}
          onClick={handleCancelar}
          sx={{ m: 1 }}
          startIcon={<CancelIcon />}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={buttonControll.btnExportaXML || loading}
          onClick={handleExportarXML}
          sx={{ m: 1 }}
          startIcon={<FileDownloadIcon />}
        >
          Exportar XML
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={buttonControll.btnEnvEmail || loading}
          onClick={handleMsgEnviarNFE}
          sx={{ m: 1 }}
          startIcon={<EmailIcon />}
        >
          Mensagem Envio
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={buttonControll.btnCorrigirNota || loading}
          onClick={handleCorrigirNota}
          sx={{ m: 1 }}
          startIcon={<EditIcon />}
        >
          Corrigir Nota
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={buttonControll.btnInutilizar || loading}
          onClick={handleInutilizar}
          sx={{ m: 1 }}
          startIcon={<BlockIcon />}
        >
          Inutilizar
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={buttonControll.btnDANFE || loading}
          onClick={handleGerarDANFE}
          sx={{ m: 1 }}
          startIcon={<PictureAsPdfIcon />}
        >
          DANFE
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={buttonControll.btnNFCE || loading}
          onClick={handleGerarNFCE}
          sx={{ m: 1 }}
          startIcon={<ReceiptLongIcon />}
        >
          NFC-e
        </Button>
      </Box>

      {/* Tabela de NF-es */}
      <TableContainer component={Paper} sx={{ mb: 3 }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox
                  indeterminate={selectedNfes.length > 0 && selectedNfes.length < nfeList.length}
                  checked={selectedNfes.length === nfeList.length}
                  onChange={() => {
                    if (selectedNfes.length === nfeList.length) {
                      setSelectedNfes([]);
                    } else {
                      setSelectedNfes(nfeList);
                    }
                  }}
                />
              </TableCell>
              <TableCell>Nota Fiscal</TableCell>
              <TableCell>Data Emissão</TableCell>
              <TableCell>Desc. Série</TableCell>
              <TableCell>Cliente</TableCell>
              <TableCell>CPF/CNPJ</TableCell>
              <TableCell>INSC. Estadual</TableCell>
              <TableCell>Valor Total</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {nfeList.map((nfe, index) => {
              const isItemSelected = isSelected(nfe);
              return (
                <TableRow
                  key={nfe.numero}
                  hover
                  role="checkbox"
                  aria-checked={isItemSelected}
                  selected={isItemSelected}
                  onClick={(e) => handleRowClick(e, nfe, index)}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={isItemSelected}
                      onClick={(e) => e.stopPropagation()}
                      onChange={() => {
                        if (isSelected(nfe)) {
                          setSelectedNfes(selectedNfes.filter((item) => item.numero !== nfe.numero));
                        } else {
                          setSelectedNfes([...selectedNfes, nfe]);
                        }
                        setLastSelectedIndex(index);
                      }}
                    />
                  </TableCell>
                  <TableCell>{nfe.numero || '-'}</TableCell>
                  <TableCell>{formatDate(nfe.dataEmissao)}</TableCell>
                  <TableCell>{nfe.descricaoSerieNfe || '-'}</TableCell>
                  <TableCell>{nfe.nomeDest || '-'}</TableCell>
                  <TableCell>{nfe.cpfCnpjDest || '-'}</TableCell>
                  <TableCell>{nfe.inscEstDest || '-'}</TableCell>
                  <TableCell>{nfe.totalIcmsVlrNF != null ? nfe.totalIcmsVlrNF.toFixed(2) : '-'}</TableCell>
                  <TableCell>{renderStatus(nfe.statusSefaz)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Paginação */}
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      {/* Popup (Dialog) para exibir a resposta da API */}
      <Dialog open={popupOpen} onClose={() => setPopupOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>{popupTitle}</DialogTitle>
        <DialogContent dividers>
          {popupContent.map((line, index) => (
            <Typography key={index} variant="body1" gutterBottom>
              {line}
            </Typography>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPopupOpen(false) } color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default NfeList;
